// extracted by mini-css-extract-plugin
export var readonly = "_jb-1";
export var star = "_jb-0";